module.exports = __webpack_public_path__ + "img/illustrator-noInternet.8e4845ac.svg";